import axios from 'axios'
import * as types from '../mutation-types'

// state
export const state = {
  loading: false,
  set_update_total_amount: null,
  error: null,
}

// mutations
export const mutations = {
  [types.SET_UPDATE_TOTAL_AMOUNT_PAY_JOBS_START] (state) {
    state.loading = true
    state.set_update_total_amount = null
    state.error = null
  },

  [types.SET_UPDATE_TOTAL_AMOUNT_PAY_JOBS_SUCCESS] (state, { data }) {
    state.loading = false
    state.set_update_total_amount = data
    state.error = null
  },

  [types.SET_UPDATE_TOTAL_AMOUNT_PAY_JOBS_ERROR] (state, { error }) {
    state.loading = false
    state.set_update_total_amount = null
    state.error = error
  },
}

export const actions = {
  async updateTotalAmountPayJobs ({ commit }, { path, id, params }) {
    try {
      commit(types.SET_UPDATE_TOTAL_AMOUNT_PAY_JOBS_START)

      const { data } = await axios.patch(`/api/${path}/update_total_amount_pay_jobs/${id}`, params)

      commit(types.SET_UPDATE_TOTAL_AMOUNT_PAY_JOBS_SUCCESS, { data: data })
    } catch (e) {
      commit(types.SET_UPDATE_TOTAL_AMOUNT_PAY_JOBS_ERROR, { error: e })
    }
  },
}

// getters
export const getters = {
  loadingSetUpdateTotalAmount: state => state.loading,
  setUpdateTotalAmount: state => state.set_update_total_amount,
  errorSetUpdateTotalAmount: state => state.error,
}
